import { render, staticRenderFns } from "./father_request_edit.vue?vue&type=template&id=63d22e10&scoped=true"
import script from "./father_request_edit.vue?vue&type=script&lang=js"
export * from "./father_request_edit.vue?vue&type=script&lang=js"
import style0 from "./father_request_edit.vue?vue&type=style&index=0&id=63d22e10&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63d22e10",
  null
  
)

export default component.exports